import { useState, useEffect, useRef } from "react";
import DoctorsTable from "./DoctorsTable";
import DoctorsGrid from "./DoctorsGrid";
import Offcanvas from "react-bootstrap/Offcanvas";
import Accordion from "react-bootstrap/Accordion";
import { Whisper, Tooltip } from "rsuite";
import { RiGridFill, RiListUnordered } from "react-icons/ri";
import { FiFilter, FiUser, FiSearch, FiX  } from "react-icons/fi"; 
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BiCheck } from "react-icons/bi";
import { SiTicktick } from "react-icons/si";
import { IoClose } from "react-icons/io5";
import DoctorViewFilters from "./ClinicComponent/Filters/ClinicFilterJSON/DoctorView";
import DefaultPatientFilters from "./ClinicComponent/Filters/DefaultPatientFilters";
import { useLazyGetalldoctorsQuery, usePostFilteredDoctorsMutation } from "../State/Api/AdddocApiSlice";

function Doctors() {
  const [show, setShow] = useState(false);
  const [patientDetail, setPatientDetail] = useState("");
  const [doctorDetail, setDoctorDetail] = useState("");
    const [selectedFilters, setSelectedFilters] = useState({});
      const gridRef = useRef(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
   const [hasData, setHasData] = useState(true);

  const [activeView, setActiveView] = useState("list");

  const getButtonClasses = (view) => {
    const isActive = activeView === view;
    return [
      "flex-1 flex items-center justify-center h-[36px] w-[50px] transition-all",
      isActive
        ? "bg-[#203342] text-white"
        : "bg-white text-[#203342] hover:bg-gray-100",
    ].join(" ");
  };

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.showToast) {
      const { toastTitle, toastSubtitle } = location.state;

      toast(
        <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
          <div
            style={{
              backgroundColor: "#2A9D8F",
              borderRadius: "8px",
              padding: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "32px",
              width: "32px",
            }}
          >
            <SiTicktick color="#fff" size={20} />
          </div>
          <div>
            <div
              style={{
                fontWeight: "600",
                fontSize: "1rem",
                color: "#fff",
                marginBottom: "4px",
              }}
            >
              {toastTitle}
            </div>
            <div
              style={{
                fontSize: "0.9rem",
                lineHeight: "1.4",
                color: "#fff",
              }}
            >
              {toastSubtitle}
            </div>
          </div>
        </div>,
        {
          icon: false,
          autoClose: 5000,
          closeOnClick: false,
          draggable: true,
          closeButton: ({ closeToast }) => (
            <button
              onClick={closeToast}
              style={{
                background: "transparent",
                border: "none",
                color: "#ffffff",
                fontSize: "1.25rem",
                cursor: "pointer",
                position: "absolute",
                top: "12px",
                right: "12px",
              }}
            >
              <IoClose />
            </button>
          ),
          style: {
            width: "22rem",
            background: "linear-gradient(135deg, #32BB71 18%, #2A9D8F 100%)",
            borderRadius: "16px",
            border: "1px solid #43D590",
            padding: "20px 24px",
            fontFamily: "Inter, sans-serif",
            boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
            position: "relative",
          },
          progressStyle: {
            background: "#ffffff",
            height: "4px",
            borderRadius: "0 0 16px 16px",
          },
        }
      );

      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);

  // Doctors.jsx (add near other hooks)
useEffect(() => {
  const onStatusUpdated = () => {
    // Smooth reload of currently cached blocks
    gridRef.current?.api?.refreshInfiniteCache();

  };

  window.addEventListener("doctors:status-updated", onStatusUpdated);
  return () => window.removeEventListener("doctors:status-updated", onStatusUpdated);
}, []);


  const clinicUserId = localStorage.getItem("userClinicID");

  useEffect(() => {
    if (clinicUserId) {
      fetchDoctors(clinicUserId);
    }
  }, [clinicUserId]);

  const [postFilteredDoctors, { isLoading: isPosting, isSuccess: isPostingSuccess, isFetching: isPostingFetching }] = usePostFilteredDoctorsMutation();

  const [fetchDoctors, { data = [], isFetching, isSuccess, isLoading }] =
    useLazyGetalldoctorsQuery();


const getDoctors = async (pageNumber, filters, sortColumn = "", sortOrder = "") => {
  try {
    const result = await postFilteredDoctors({
      pageNumber,
      pageSize: 100,
      userClinicID: clinicUserId,
      filters,
      sortColumn: sortColumn,
      sortOrder: sortOrder
    }).unwrap();

    return result;
  } catch (err) {
    console.error("Error fetching doctors:", err);
    return [];
  }
};



  useEffect(() => {

    gridRef?.current?.api?.purgeInfiniteCache();

  }, [selectedFilters]);

  const handleSearch = () => {
  const searchValue = doctorDetail.trim(); // assuming you have doctorDetail state

  if (!searchValue) {
    // Clear fullName filter if input is empty
    setSelectedFilters((prev) => {
      const { fullName, ...rest } = prev;
      return rest;
    });
    return;
  }

  // Always treat input as doctor's full name
  const newFilter = {
    fullName: {
      values: new Set([searchValue]),
      operator: "Contains",
    },
  };

  // Replace old fullName filter with new one
  setSelectedFilters((prev) => {
    const { fullName, ...rest } = prev;
    return { ...rest, ...newFilter };
  });
};

const handleClearSearch = () => {
  setDoctorDetail(""); // clear the input box
  setSelectedFilters((prev) => {
    const { fullName, ...rest } = prev;
    return rest;
  });
  setHasData(true); 
};


  return (
    <>
      <main style={{ width: "100%", height: "100%" }}>
        <div className="row">
          <div
            style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }}
            className="col-12 mb-4 d-flex flex-wrap justify-content-between align-items-center"
          >
            <div className="d-flex justify-content-between">
              <div>
                <h2 className="h3 fw-bold mb-0" style={{fontSize:'24px'}}>Doctors</h2>
                {/* <p className="text-secondary">
                  Register doctors and define their consultation timings.
                </p> */}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-end gap-3">
{/* <label className="relative w-80">
  <input
    type="text"
    className="pr-12 pl-4 py-2 border border-green-600 rounded-lg w-full text-sm placeholder-gray-400 focus:outline-none focus:border-[#7eb592] focus:ring-2 focus:ring-[#7eb592]/20"
    placeholder="Enter doctor name"
    value={doctorDetail}
    onChange={(e) => {
      const value = e.target.value;
      setDoctorDetail(value);

      if (value.trim() === "") {
        setSelectedFilters((prev) => {
          const { fullName, ...rest } = prev;
          return rest;
        });
      }
    }}
    onKeyDown={(e) => e.key === "Enter" && handleSearch()}
  />

  {doctorDetail && (
    <span
      className="absolute right-12 top-9 transform -translate-y-1/2 p-2 rounded-md text-gray-500 hover:text-red-400 cursor-pointer"
      onClick={handleClearSearch}
    >
      <FiX size={16} />
    </span>
  )}

  <span
    className="absolute right-0 top-0 bottom-0 bg-[#7eb592] hover:bg-gray-200 px-3 rounded-r-lg text-white cursor-pointer flex items-center justify-center"
    onClick={handleSearch}
  >
    <FiSearch size={16} />
  </span>
</label> */}


 <label className="relative">
                <input
                  type="text"
                  className="pr-20 pl-4 py-2 border border-[#7eb592] rounded-lg w-full text-sm   focus:outline-none ring-2 ring-[#7eb592]/20 focus:outline focus:border-[#7eb592] focus:ring-2 focus:ring-[#7eb592]/20"
                  placeholder="Enter Doctor name or ID"
                  value={doctorDetail}
                  onChange={(e) => {
                    const value = e.target.value;
                    setDoctorDetail(value);

                     if (value.trim() === "") {
        setSelectedFilters((prev) => {
          const { fullName, ...rest } = prev;
          return rest;
        });
      }
    }}
                  onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                />
                {doctorDetail && (
                  <span
                    className="absolute right-12 top-9 transform -translate-y-1/2 p-2 rounded-md text-gray-500 hover:text-red-400 cursor-pointer"
                    onClick={handleClearSearch}
                  >
                    <FiX size={16} />
                  </span>
                )}
                <span
                  className="absolute right-[0.3rem] top-9 transform -translate-y-1/2 bg-[#7eb592] hover:bg-gray-200 p-2 rounded-md text-white cursor-pointer"
                  onClick={handleSearch}
                >
                  <FiSearch size={16} />
                </span>
              </label>


              <Whisper
                  placement="top"
                  trigger="hover"
                  speaker={<Tooltip>Filter Options</Tooltip>}
                >
                  <DefaultPatientFilters 
                    defaultFilters={DoctorViewFilters.default}
                     additionalFilters={DoctorViewFilters.additional}
                       selectedFilters={selectedFilters}
                  setSelectedFilters={setSelectedFilters}
                  setHasData={setHasData}
                  />
                </Whisper>

              <button
                className="gradient-button"
                onClick={() => navigate("/DoctorsAdd")}
              >
                + Add Doctor
              </button>
              <div className="flex rounded-md overflow-hidden shadow-sm ml-[5px] w-fit">
                <Whisper
                  placement="top"
                  trigger="hover"
                  speaker={<Tooltip>List view</Tooltip>}
                >
                  <button
                    onClick={() => setActiveView("list")}
                    className={getButtonClasses("list")}
                  >
                    <RiListUnordered size={20} />
                  </button>
                </Whisper>
                <Whisper
                  placement="top"
                  trigger="hover"
                  speaker={<Tooltip>Grid view</Tooltip>}
                >
                  <button
                    onClick={() => setActiveView("grid")}
                    className={getButtonClasses("grid")}
                  >
                    <RiGridFill size={20} />
                  </button>
                </Whisper>

              </div>
            </div>
          </div>
        </div>

        {activeView === "list" && (
          <div className="row" style={{ width: "100%", height: "100%" }}>
            <div className="col-12 p-0">
              <DoctorsTable
                getDoctors={getDoctors}
                isFetching={isPostingFetching}
                isLoading={isPosting}
                isSuccess={isPostingSuccess}
                gridRef={gridRef}
                selectedFilters={selectedFilters}
                hasData={hasData}
                setHasData={setHasData}
              />
            </div>
          </div>
        )}

        {activeView === "grid" && (
          <div className="row">
            <DoctorsGrid
                getDoctors={getDoctors}
                isFetching={isPostingFetching}
                isLoading={isPosting}
                isSuccess={isPostingSuccess}
                   selectedFilters={selectedFilters}
            />
          </div>
        )}

        <Offcanvas
          show={show}
          onHide={handleClose}
          placement={"end"}
          style={{
            width: "22rem",
            margin: ".5rem .5rem",
            borderRadius: "0.5rem 0rem 0px .5rem",
          }}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title
              className="text-black"
              style={{ fontSize: "18px" }}
            >
              Filters
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="d-flex flex-column gap-2">
              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Doctor Name
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="position-relative div-okij8ijj mb-3">
                      <input
                        type="text"
                        className="form-control div-sdwfegere"
                        placeholder="Search"
                        style={{
                          padding: ".3rem .2rem",
                          borderRadius: ".3rem",
                        }}
                      />
                      <div
                        className="position-absolute"
                        style={{ top: "5px", right: ".2rem" }}
                      >
                        <button style={{ background: "none", border: "none" }}>
                          <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>Riya</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Swapna </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Hari Tej </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Narayana </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Prasad </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Subramanyam </span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Doctor ID
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="position-relative div-okij8ijj mb-3">
                      <input
                        type="text"
                        className="form-control div-sdwfegere"
                        placeholder="Search"
                        style={{
                          padding: ".3rem .2rem",
                          borderRadius: ".3rem",
                        }}
                      />
                      <div
                        className="position-absolute"
                        style={{ top: "5px", right: ".2rem" }}
                      >
                        <button style={{ background: "none", border: "none" }}>
                          <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>#P-00012</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>#P-00013 </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>#P-00014 </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>#P-00015 </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>#P-00016 </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>#P-00017 </span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Specialization
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="position-relative div-okij8ijj mb-3">
                      <input
                        type="text"
                        className="form-control div-sdwfegere"
                        placeholder="Search"
                        style={{
                          padding: ".3rem .2rem",
                          borderRadius: ".3rem",
                        }}
                      />
                      <div
                        className="position-absolute"
                        style={{ top: "5px", right: ".2rem" }}
                      >
                        <button style={{ background: "none", border: "none" }}>
                          <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>Cardioligist</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Dentist </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Physio Therapist </span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Status
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>Available</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Unavailable </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>On - Call </span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Cunsultation Type
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>In Person</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Teliconsultation </span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Date of Joining
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>Today</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>This week </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="date" className="form-control" />
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      On - Call Availabality
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="position-relative div-okij8ijj mb-3">
                      <input
                        type="text"
                        className="form-control div-sdwfegere"
                        placeholder="Search"
                        style={{
                          padding: ".3rem .2rem",
                          borderRadius: ".3rem",
                        }}
                      />
                      <div
                        className="position-absolute"
                        style={{ top: "5px", right: ".2rem" }}
                      >
                        <button style={{ background: "none", border: "none" }}>
                          <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>Riya</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Swapna </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Hari Tej </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Narayana </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Prasad </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Subramanyam </span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Shift Timing
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="position-relative div-okij8ijj mb-3">
                      <input
                        type="text"
                        className="form-control div-sdwfegere"
                        placeholder="Search"
                        style={{
                          padding: ".3rem .2rem",
                          borderRadius: ".3rem",
                        }}
                      />
                      <div
                        className="position-absolute"
                        style={{ top: "5px", right: ".2rem" }}
                      >
                        <button style={{ background: "none", border: "none" }}>
                          <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>Morning</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Afternoon </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Evening </span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Doctors with Apointments Today
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="position-relative div-okij8ijj mb-3">
                      <input
                        type="text"
                        className="form-control div-sdwfegere"
                        placeholder="Search"
                        style={{
                          padding: ".3rem .2rem",
                          borderRadius: ".3rem",
                        }}
                      />
                      <div
                        className="position-absolute"
                        style={{ top: "5px", right: ".2rem" }}
                      >
                        <button style={{ background: "none", border: "none" }}>
                          <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>Riya</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Swapna </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Hari Tej </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Narayana </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Prasad </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Subramanyam </span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-1 pt-1 pb-1">
                    <span
                      style={{
                        letterSpacing: "1px",
                        fontSize: "16px",
                        color: "#000",
                        fontWeight: "600",
                      }}
                    >
                      Workload Status
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ padding: ".5rem .4rem" }}>
                    <div className="d-flex align-items-center gap-2">
                      <input type="checkbox" />
                      <span>Low</span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>Medium </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mt-3">
                      <input type="checkbox" />
                      <span>High </span>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
        <ToastContainer
          position="top-right"
          autoClose={10000}
          hideProgressBar={false}
          pauseOnHover
          theme="light"
        />
      </main>
    </>
  );
}

export default Doctors;